import React from 'react';
import PropTypes from 'prop-types';
import { InternalLink } from 'smartsuite-ui';
import { getNonApiUri } from '../../utils/getUri';

function getFlightLink(id) {
    return getNonApiUri(
        `Common.Airport/Query/FlightDetails.aspx?flight_id=${id}`
    );
}

export default function FlightDetailLink(props) {
    if (!props.hasAccess || !props.id) {
        return <span>{props.children}</span>;
    }

    return (
        <InternalLink
            canViewLink={true}
            href={getFlightLink(props.id)}
            openInNewTab={props.openInNewTab}
        >
            {props.children}
        </InternalLink>
    );
}

FlightDetailLink.propTypes = {
    id: PropTypes.number,
    hasAccess: PropTypes.bool.isRequired,
    children: PropTypes.node.isRequired,
    openInNewTab: PropTypes.bool,
};

FlightDetailLink.defaultProps = {
    id: null,
    openInNewTab: false,
};
